enum Environment {
  Production = 'prd',
  Staging = 'stg',
  Development = 'dev',
}
export default Environment;
